import { NameType, Payload, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { COLORS } from "../components/recharts/ReCharts";
import { LabelPosition } from "recharts/types/component/Label";
import { ReactNode } from "react";
import { COLOR_CODES } from "../common";

export interface ReChartData {
    [key: string]: number | string | Date | null | undefined;
  }
  
  export enum ChartType {
    Line,
    Bar,
    Area,
  }
  
  export interface LegendKey {
    name?: string;
    stroke?: string;
    dataKey: string;
    type?: ChartType;
    
    yAxisId?: string;
    legendColor?:string;
    unit?: string;
    stackId?: string;
    isDash?: boolean;
    [key: string]: any;
    // color: string;
  }
  
  export const BAR_RADIUS: number | [number, number, number, number] = [
    4, 4, 0, 0,
  ];
  
  export function getColorList(length: number) {
    let colors = [];
    for (let i = 0; i < length; i++) {
      colors.push(Object.values(COLOR_CODES)[i % COLORS.length]);
    }
    return colors;
  }
  
  export enum BrushStart {
    Start,
    End,
  }

  interface BrushIndex{
    startIndex: number;
    endIndex: number;
  }

export interface ChartArguements {
    data: ReChartData[];
    legends: LegendKey[];
    legendBreakIndex?: number;
    syncid?: string;
    unit?: string;
    labelFontSize?: number;
    onLegendChange?: (legends: LegendKey[]) => void;
    xDataKey: string;
    circleLegend?: boolean;
    xTick? : any ; 
    disableLegendClick?: boolean;
    barCategoryGap?: number;
    maxBarSize?: number;
    perpendicularBarLab?: boolean;
    xLabel?: string;
    onlyTitle?: boolean;
    xAxisLabelPosition?: LabelPosition;
    disableLegend?: boolean;
    yAxisWidth?: number;
    barFontSize?: number;
    xaxisHeight? : number;
    xAxisAngle?: number;
    secondXAxisHeight?: number;
    xAxisTickMargin?: number;
    secondXAxisLabel?: string;
    secondXDataKey?: string;
    secondYAxisWidth?: number;
    yAxisLabel?: string;
    fontSize?: number;
    showBarLabel?: boolean;
    isTimeSlot?: boolean;
    hidePrice?: boolean;
    showBrush?: boolean;
    xAxisLabelOffset?: number;
    brushHeight?: number;
    rendexSecondXTick?: any;
    labelFormatter?: (label: any, payload: Array<Payload<ValueType, NameType>>) => ReactNode;
    nameFormatter?: (name: string) => ReactNode;
    brushIndex?: BrushIndex;
    brushStart?: BrushStart;
    secondYAxisLabel?: string;
    showSecondYAxis?: boolean;
}


export interface ChartRecord{
  total_volume_mwh: number;
  weighted_average_price: number;
  [key: string]: any;
}

